import { useEffect } from "react";
import { trace } from "firebase/performance";
import { perf } from "../../firebase";

/**
 * Registra una traza de Firebase Performance mientras el componente está montado.
 * No-op si Firebase Performance no está habilitado (REACT_APP_ENABLE_PERF=true).
 */
export function usePerfTrace(screenName) {
  useEffect(() => {
    if (!screenName || !perf) return;
    const t = trace(perf, `perf_${screenName}`);
    t.start();
    return () => {
      t.stop();
    };
  }, [screenName]);
}
